import { ArrayHelper } from '@/helper/arrayHelper';
import { DebugHelper } from "@/helper/debugHelper";

export class InsertionData
{
    // 列名候補
    static readonly COLUMN_HEADER_CAPTION = [ 

        "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z",
        "AA", "AB", "AC", "AD", "AE", "AF", "AG", "AH", "AI", "AJ", "AK", "AL", "AM", "AN", "AO", "AP", "AQ", "AR", "AS", "AT", "AU", "AV", "AW", "AX", "AY", "AZ",
        "BA", "BB", "BC", "BD", "BE", "BF", "BG", "BH", "BI", "BJ", "BK", "BL", "BM", "BN", "BO", "BP", "BQ", "BR", "BS", "BT", "BU", "BV", "BW", "BX", "BY", "BZ",
    ];
    static readonly COLUMN_COUNT_MAX = InsertionData.COLUMN_HEADER_CAPTION.length;
    static readonly COLUMN_COUNT_INIT = 26;

    // 1行目を列名にするか
    private _isFirstRowAsColumnName : boolean = false;
    public get isFirstRowAsColumnName() { return this._isFirstRowAsColumnName; }
    public set isFirstRowAsColumnName(isFirstRowAsColumnName) 
    { 
        this._isFirstRowAsColumnName = isFirstRowAsColumnName;
    }

    // 差し込み方向
    // 0 : 横方向(default) 左上->右上->左下->右下
    // 1 : 縦方向 左上->左下->右上->右下
    private _insertionDirection = 0;
    public get insertionDirection() { return this._insertionDirection; }
    public set insertionDirection(insertionDirection) { this._insertionDirection = insertionDirection; }

    // 開始行
    private _startRow = 0;
    public get startRow() { return this._startRow; }
    public set startRow(startRow) { this._startRow = startRow; }

    // 終了行
    private _endRow = 0;
    public get endRow() { return this._endRow; }
    public set endRow(endRow) { this._endRow = endRow; }

    // 開始面
    private _offset = 0;
    public get offset() { return this._offset; }
    public set offset(offset) { this._offset = offset; }

    // 各行の印刷枚数(実際は各行設定にこの値を乗じる)
    private _printCount = 1;
    public get printCount() { return this._printCount; }
    public set printCount(printCount) { this._printCount = printCount; }

    // 列データ
    private _columnDataArray : Array<ColumnData> = new Array();
    public get columnDataArray() { return this._columnDataArray; }
    public set columnDataArray(columnDataArray) { this._columnDataArray = columnDataArray; }
    public getColumnDataCount() { return this._columnDataArray.length; }
    public getColumnData(index : number)
    {
        return this._columnDataArray[index];
    }

    // 列データの追加
    public addColumnData(insertionId : string = "", prefix = "", suffix = "") 
    {
        var count = this.getColumnDataCount();
        // 最大を超える場合は何もしない
        if(count + 1 > InsertionData.COLUMN_COUNT_MAX) { return; }
        var newData = new ColumnData();
        newData.insertionId = insertionId;
        newData.prefix = prefix;
        newData.suffix = suffix;
        this._columnDataArray = ArrayHelper.add(this._columnDataArray, newData);
        // ヘッダーテキストの振り直し
        this.resetColumnDataHeader();
        // 行データのセル更新
        for(var i = 0; i < this.getRowDataCount(); ++i)
        {
            var rowData = this.getRowData(i);
            rowData.cellDataArray = ArrayHelper.add(rowData.cellDataArray, new CellData());
        }
    }

    // 列データの挿入
    public insertColumnData(index : number, insertionId : string = "")
    {
        var count = this.getColumnDataCount();
        // 最大を超える場合は何もしない
        if(count + 1 > InsertionData.COLUMN_COUNT_MAX) { return; }
        var newData = new ColumnData();
        newData.insertionId = insertionId;
        this._columnDataArray = ArrayHelper.insert(this._columnDataArray, newData, index);
        // ヘッダーテキストの振り直し
        this.resetColumnDataHeader();
        // 行データのセル更新
        for(var i = 0; i < this.getRowDataCount(); ++i)
        {
            var rowData = this.getRowData(i);
            rowData.cellDataArray = ArrayHelper.insert(rowData.cellDataArray, new CellData(), index);
        }
    }

    // 列データの削除
    public removeColumnData(index : number)
    {
        this._columnDataArray = ArrayHelper.removeAt(this._columnDataArray, index);
        // ヘッダーテキストの振り直し
        this.resetColumnDataHeader();
        // 行データのセル更新
        for(var i = 0; i < this.getRowDataCount(); ++i)
        {
            var rowData = this.getRowData(i);
            rowData.cellDataArray = ArrayHelper.removeAt(rowData.cellDataArray, index);
        }
    }

    // ヘッダーテキストの振り直し
    public resetColumnDataHeader()
    {
        var newArray = ArrayHelper.clone(this._columnDataArray);
        for(var i = 0; i < this._columnDataArray.length; ++i)
        {
            newArray[i].headerText = InsertionData.COLUMN_HEADER_CAPTION[i];
        }
        this._columnDataArray = newArray;
    }

    // 行データ
    private _rowDataArray : Array<RowData> = new Array();
    public get rowDataArray() { return this._rowDataArray; }
    public set rowDataArray(rowDataArray) { this._rowDataArray = rowDataArray; }
    public getRowDataCount() { return this._rowDataArray.length; }
    public getRowData(index : number)
    {
        return this._rowDataArray[index];
    }

    // 行データの追加
    public addRowData()
    {
        var newData = new RowData();
        var cellDataArray = new Array();
        for(var i = 0; i < this._columnDataArray.length; ++i)
        {
            cellDataArray.push(new CellData());
        }
        newData.cellDataArray = cellDataArray;
        this._rowDataArray = ArrayHelper.add(this._rowDataArray, newData);
        // 終了行の更新
        this.endRow = this._isFirstRowAsColumnName ? this._rowDataArray.length - 2 : this._rowDataArray.length - 1;
    }

    // 行データの挿入
    public insertRowData(index : number)
    {
        var newData = new RowData();
        var cellDataArray = new Array();
        for(var i = 0; i < this._columnDataArray.length; ++i)
        {
            cellDataArray.push(new CellData());
        }
        newData.cellDataArray = cellDataArray;
        this._rowDataArray = ArrayHelper.insert(this._rowDataArray, newData, index);
        // 終了行の更新
        this.endRow = this._isFirstRowAsColumnName ? this._rowDataArray.length - 2 : this._rowDataArray.length - 1;
    }

    // 行データの削除
    public removeRowData(index : number)
    {
        this._rowDataArray = ArrayHelper.removeAt(this._rowDataArray, index);
        // 開始・終了行の更新
        this.endRow = this._isFirstRowAsColumnName ? this._rowDataArray.length - 2 : this._rowDataArray.length - 1;
        if(this._startRow > this._endRow) { this._startRow = this._endRow; }
    }

    // 行データの並び替え
    // isAscending : true 昇順にする false 逆順にする 
    // columnIndex : 基準とする列インデックス
    public orderRowDataArray(isAscending : boolean, columnIndex : number)
    {
        if(columnIndex < 0 || this._columnDataArray.length <= columnIndex) { return; }

        var newArray : Array<RowData>= [];

        if(this._isFirstRowAsColumnName)
        {
            // 並び替えの対象とする行データは
            // 1行目を列名にする -> 2行目〜
            // 3行未満の場合は何も行わない
            if(this._rowDataArray.length < 3) return;
            for(var idx = 0; idx < this._rowDataArray.length; ++idx)
            {
                if (idx == 0) continue;
                newArray.push(this._rowDataArray[idx]);
            }
        }
        else
        {
            newArray = this._rowDataArray.slice();
        }

        
        // 昇順・降順並び替え
        newArray.sort((a, b) =>
        {
            if(columnIndex < 0 || a.cellDataArray.length <= columnIndex || b.cellDataArray.length <= columnIndex) { return 0; }
            var contentA = a.cellDataArray[columnIndex].content;
            var contentB = b.cellDataArray[columnIndex].content;
            if(contentA < contentB) { return isAscending ? -1 : 1; }
            else if(contentA > contentB) { return isAscending ? 1 : -1; }
            return 0;
        });

        if(this._isFirstRowAsColumnName)
        {
            // 1行目を追加する
            newArray.splice(0, 0, this._rowDataArray[0]);
        }

        this._rowDataArray = newArray;
    }
    
    // セルデータ
    public getCellData(row : number, col : number)
    {
        if(0 <= row && row < this.getRowDataCount())
        {
            var rowData = this.getRowData(row);
            if(0 <= col && col < rowData.cellDataArray.length)
            {
                return rowData.cellDataArray[col];
            }
        }

        return null;
    }
    public setCellData(type : number, content : string, row : number, col : number)
    {
        var data = new CellData();
        data.type = type;
        data.content = content;
        if(0 <= row && row < this.getRowDataCount())
        {
            var rowArrayClone = ArrayHelper.clone(this.rowDataArray);
            if(0 <= col && col < rowArrayClone[row].cellDataArray.length)
            {
                
                rowArrayClone[row].cellDataArray[col] = data;
                this.rowDataArray = rowArrayClone;
            }
        }
    }

    // セルデータが存在するか
    public hasAnyData()
    {
        var result = false;
        var isBreak = false;
        for(var row = 0; row < this.getRowDataCount(); ++row)
        {
            var rowData = this.getRowData(row);
            for(var col = 0; col < this.getColumnDataCount(); ++col)
            {
                var cellData = rowData.cellDataArray[col];

                if(cellData.content != "") 
                { 
                    result = true;
                    isBreak = true;
                    break;
                }
            }
            if(isBreak) { break; }
        }
        
        return result;
    }

    // データをcsvテキストとして得る
    public getCsv() : string
    {
        var csv = "";

        for(var row = 0; row < this.getRowDataCount(); ++row)
        {
            var line = "";
            for(var col = 0; col < this.getColumnDataCount(); ++col)
            {
                var cellData = this.getCellData(row, col);
                var text = cellData != null ? cellData.content : "";

                if(col > 0) { line += ","; }
                line += text;
            }
            // 改行
            if(row > 0) { csv += "\n"; }
            // 行追加
            csv += line;
        }

        return csv;
    }

    public static create()
    {
        var insertData = new InsertionData();

        // 初期化
        insertData.addRowData();
        for(var i = 0; i < InsertionData.COLUMN_COUNT_INIT; ++i)
        {
            insertData.addColumnData();
        }

        return insertData;
    }


    // CSVファイルから構築する
    // csv : csv文字列
    // originalData : 元となるinsertionData nullでなければこのデータの差し込み先情報を反映する
    public static createFromCsv(csv : string, originalData : InsertionData | null = null)
    {
        var succeed = false;
        var insertionData = new InsertionData();
        // 1行目を列名にする設定をコピー
        if(originalData != null) { insertionData.isFirstRowAsColumnName = originalData.isFirstRowAsColumnName; }

        try
        {
            succeed = insertionData.createFromCsvCore(csv, originalData);
        }
        catch(e)
        {
            DebugHelper.trace(e);
        }

        if(!succeed)
        {
            // 失敗した場合はorginalDataがあればそれを使用、なければデフォルト
            insertionData = originalData != null ? originalData : this.create();
        }

        return insertionData;
    }

    public createFromCsvCore(csv : string, originalData : InsertionData | null = null)
    {
        // csvを改行で分割
        var lines = csv.split(/\r?\n/g);
        // 1行未満は解釈しない
        if(lines.length < 1) { return false; }
        // すべての行のうち、カンマ区切りして最大個数を数える
        // また、行を追加していく
        var maxCellCount = 0;
        let cellDataMap : Array<Array<string>> = [];
        for(var lineIndex = 0; lineIndex < lines.length; ++lineIndex)
        {         
            if(lineIndex == lines.length - 1 && lines.length >= 2 && lines[lineIndex] == "")
            {
                // 最終行に空白が入っている場合があるので、その場合は何も行わない
                continue;
            }
            let lineCellData = this.createStringArrayFromCsvLine(lines[lineIndex]);
            cellDataMap.push(lineCellData);
            maxCellCount = Math.max(lineCellData.length, maxCellCount);
            this.addRowData();
        }
        // 1セル未満は解釈しない
        if(maxCellCount < 1) { return false; }
        // 列最大数チェック
        if(maxCellCount > InsertionData.COLUMN_COUNT_MAX) { maxCellCount = InsertionData.COLUMN_COUNT_MAX; }

        // 列追加
        for(var col = 0; col < maxCellCount; ++col)
        {
            // 元の差し込みid, 語頭, 語尾を取得する
            var insertionId = "";
            var prefix = "";
            var suffix = "";
            if(originalData != null && originalData.getColumnDataCount() > col)
            {
                var colData = originalData.getColumnData(col);
                insertionId = colData.insertionId;
                prefix = colData.prefix;
                suffix = colData.suffix;
            }
            // 列を１つ追加
            this.addColumnData(insertionId, prefix, suffix);
        }

        // セル
        for(var row = 0; row < lines.length; ++row)
        {
            if(cellDataMap.length <= row) continue;
            let lineCellData = cellDataMap[row]; 
            for(var index = 0; index < lineCellData.length; ++index)
            {
                if(index > maxCellCount) { continue; }

                var text = lineCellData[index];
                // if(text.length >= 2)
                // {
                //     var first = text.substr(0, 1);
                //     var last = text.substr(text.length - 1, 1);
                //     if((first == '"' && last == '"') || (first == "'" && last == "'"))
                //     {
                //         // 最初と最後のコーテーションを外す
                //         text = text.length > 2 ? text.substr(1, text.length - 2) : ""; 
                //     }
                // }
                // セルテキスト
                this.setCellData(0, text, row, index);
            }
        }

        return true;
    }

    createStringArrayFromCsvLine(line : string) : Array<string>
    {
        let array : Array<string> = [];

        if(line.length == 0)
        {
            // 空白の場合はからの行列を返す
            return array;
        }

        let words = "";
        let isStartedWQ = false;
        let i = 0;
        while(i < line.length)
        {
            let chara = line.substr(i, 1);
            let next = i + 1 < line.length ? line.substr(i + 1, 1) : null;

            if(isStartedWQ)
            {
                // " からスタートした
                if(chara === '"' && next === '"')
                {
                    // "" は " に直して追加
                    words += '"';
                    i++;
                }
                else if(chara === '"')
                {
                    // 単独の" があったのでここで区切る
                    array.push(words);
                    words = "";
                    isStartedWQ = false;
                    if(next === ',')
                    {
                        // 次に, があったらスキップする
                        i++;
                    }
                }
                else
                {
                    // その他の文字は追加
                    words += chara;
                }
            }
            else if(words.length > 0)
            {
                // , 直後の文字からスタートした
                if(chara === ',')
                {
                    // , があったのでここで区切る
                    array.push(words);
                    words = "";
                }
                else if(chara === '"' && next === '"')
                {
                    // " が連続しているときは、" ひとつにする
                    words += '"';
                    i++;
                }
                else
                {
                    // その他の文字は追加
                    words += chara;
                }
            }
            else
            {
                // 最初の文字検索
                if(chara === '"')
                {
                    // " でスタート
                    isStartedWQ = true;
                }
                else if(chara === ',')
                {
                    // (ブランク), となっているので、空白を追加する
                    array.push("");
                }
                else
                {
                    // この文字から始める
                    words += chara;
                }
            }
            i++;
        }

        if(words.length > 0)
        {
            // 残った文字列を追加
            array.push(words);
        }
        else if(line.substr(line.length - 1, 1) == ',')
        {
            // 最後が区切り , で終わっているので、空白を追加する
            array.push("");
        }

        return array;
    }

    // XLSXファイルから構築する
    // xlsx : xlsxファイルを文字列化したもの
    // originalData : 元となるinsertionData nullでなければこのデータの差し込み先情報を反映する
    public static createFromXlsx(xlsx : string, originalData : InsertionData | null = null)
    {
        var succeed = false;
        var insertionData = new InsertionData();
        // 1行目を列名にする設定をコピー
        if(originalData != null) { insertionData.isFirstRowAsColumnName = originalData.isFirstRowAsColumnName; }

        try
        {
            succeed = insertionData.createFromXlsxCore(xlsx, originalData);
        }
        catch(e)
        {
            DebugHelper.trace(e);
        }

        if(!succeed)
        {
            // 失敗した場合はorginalDataがあればそれを使用、なければデフォルト
            insertionData = originalData != null ? originalData : this.create();
        }

        return insertionData;
    }

    public createFromXlsxCore(xlsx : string, originalData : InsertionData | null = null)
    {
        // jsonをパース
        var jsonObj = JSON.parse(xlsx);
        DebugHelper.trace(jsonObj);
        // 配列ではない or　中身がない場合は無効
        if(!(jsonObj instanceof Array) || (jsonObj instanceof Array && jsonObj.length == 0)) { return false; }
        // 配列をループする
        var rowArray = jsonObj as Array<any>;
        // 列追加
        var maxCellCount = 0;
        for(var row = 0; row < rowArray.length; ++row)
        {
            this.addRowData();
        }

        // セル
        for(var row = 0; row < rowArray.length; ++row)
        {
            var item = rowArray[row];
            // キーを探す
            for(var index = 0; index < InsertionData.COLUMN_COUNT_MAX; ++index)
            {
                var key = InsertionData.COLUMN_HEADER_CAPTION[index];
                if(item[key] != null && typeof(item[key]) == "string")
                {
                    var text = item[key] as string;
                    // 改行コードがCR+LFだった場合、LFのみに変換する
                    text = text.replace(/\r\n/g, "\n");
                    if(text.length >= 2)
                    {
                        var first = text.substr(0, 1);
                        var last = text.substr(text.length - 1, 1);
                        if((first == '"' && last == '"') || (first == "'" && last == "'"))
                        {
                            // 最初と最後のコーテーションを外す
                            text = text.length > 2 ? text.substr(1, text.length - 2) : ""; 
                        }
                    }
                    if(text != "")
                    {
                        // 追加使用しているcolumnが存在しないときは追加
                        if(this.getColumnDataCount() <= index)
                        {
                            for(var col = this.getColumnDataCount(); col <= index; ++col)
                            {
                                // 元の差し込みid, 語頭, 語尾を取得する
                                var insertionId = "";
                                var prefix = "";
                                var suffix = "";
                                if(originalData != null && originalData.getColumnDataCount() > col)
                                {
                                    var colData = originalData.getColumnData(col);
                                    insertionId = colData.insertionId;
                                    prefix = colData.prefix;
                                    suffix = colData.suffix;
                                }
                                this.addColumnData(insertionId, prefix, suffix);
                            }
                        }
                        // セルテキスト
                        this.setCellData(0, text, row, index);
                    }
                }
            }
        }

        // 列がなかった場合は失敗
        if(this.getColumnDataCount() == 0) { return false; }

        return true;
    }

    public clone()
    {
        var cloned = new InsertionData();
        for(var i = 0; i < this.rowDataArray.length; ++i)
        {
            cloned.rowDataArray.push(this.rowDataArray[i].clone());
        }
        for(var i = 0; i < this.columnDataArray.length; ++i)
        {
            cloned.columnDataArray.push(this.columnDataArray[i].clone());
        }
        return cloned;
    }

    // JSON
    public toJSON()
    {
        // JSONパース用オブジェクト
        var cloneObj = {
            isFirstRowAsColumnName : this._isFirstRowAsColumnName,
            insertionDirection : this._insertionDirection,
            startRow : this._startRow,
            endRow : this._endRow,
            offset : this._offset,
            printCount : this._printCount,
            columnDataArray : this._columnDataArray,
            rowDataArray : this._rowDataArray,
        };

        return cloneObj;
    }


    public static createFromJsonData(jsonData : any)
    {
        var insertionData = new InsertionData();
        if(jsonData.isFirstRowAsColumnName != null) { insertionData.isFirstRowAsColumnName = jsonData.isFirstRowAsColumnName; }
        if(jsonData.insertionDirection != null) { insertionData.insertionDirection = jsonData.insertionDirection; }
        if(jsonData.startRow != null) { insertionData.startRow = jsonData.startRow; }
        if(jsonData.endRow != null) { insertionData.endRow = jsonData.endRow; }
        if(jsonData.offset != null) { insertionData.offset = jsonData.offset; }
        if(jsonData.printCount != null) { insertionData.printCount = jsonData.printCount; }
        if(jsonData.columnDataArray != null)
        {
            for(var i = 0; i < jsonData.columnDataArray.length; ++i)
            {
                insertionData._columnDataArray.push(ColumnData.createFromJsonData(jsonData.columnDataArray[i]));
            }
        }
        if(jsonData.rowDataArray != null)
        {
            for(var i = 0; i < jsonData.rowDataArray.length; ++i)
            {
                insertionData._rowDataArray.push(RowData.createFromJsonData(jsonData.rowDataArray[i]));
            }
        }

        // データの異常でcolumnDataの数よりcellDataの数が少なくなるケースがあり、その場合エラーが起こるので、調整する
        insertionData.fixRowData();

        return insertionData;
    }

    public fixRowData()
    {
        for(var r = 0; r < this.rowDataArray.length; ++r)
        {
            var row = this.rowDataArray[r];
            if(row.cellDataArray.length < this.columnDataArray.length)
            {
                var delta = this.columnDataArray.length - row.cellDataArray.length;
                for(var i = 0; i < delta; ++i)
                {
                    row.cellDataArray.push(new CellData());
                }
            }
        }
    }
}

export class ColumnData
{
    // 列テキスト(A,B,...AA,...)
    public headerText : string = "";
    // 対応先のinsersionId
    public insertionId : string = "";
    // 語頭
    public prefix : string = "";
    // 語尾
    public suffix : string = "";

    public clone()
    {
        var cloned = new ColumnData();
        cloned.headerText = this.headerText;
        cloned.insertionId = this.insertionId;
        cloned.prefix = this.prefix;
        cloned.suffix = this.suffix;
        return cloned;
    }

    // JSON
    public toJSON()
    {
        // JSONパース用オブジェクト
        var cloneObj = {
            headerText : this.headerText,
            insertionId : this.insertionId,
            prefix : this.prefix,
            suffix : this.suffix
        };

        return cloneObj;
    }

    public static createFromJsonData(jsonData : any)
    {
        var data = new ColumnData();
        if(jsonData.headerText != null) { data.headerText = jsonData.headerText; }
        if(jsonData.insertionId != null) { data.insertionId = jsonData.insertionId; }
        if(jsonData.prefix != null) { data.prefix = jsonData.prefix; }
        if(jsonData.suffix != null) { data.suffix = jsonData.suffix; }
        return data;
    }
}

export class RowData
{
    // 印刷
    public isPrint : boolean = true;
    // 印刷枚数
    public printCount : number = 1;
    // セルデータ配列
    public cellDataArray : Array<CellData> = new Array();

    public clone()
    {
        var cloned = new RowData();
        cloned.isPrint = this.isPrint;
        cloned.printCount = this.printCount;
        for(var i = 0; i < this.cellDataArray.length; ++i)
        {
            cloned.cellDataArray.push(this.cellDataArray[i].clone());
        }
        return cloned;
    }

    // JSON
    public toJSON()
    {
        // JSONパース用オブジェクト
        var cloneObj = {
            isPrint : this.isPrint,
            printCount : this.printCount,
            cellDataArray : this.cellDataArray
        };

        return cloneObj;
    }

    public static createFromJsonData(jsonData : any)
    {
        var data = new RowData();
        if(jsonData.isPrint != null) { data.isPrint = jsonData.isPrint; }
        if(jsonData.printCount != null) { data.printCount = jsonData.printCount; }
        if(jsonData.cellDataArray != null)
        {
            for(var i = 0; i < jsonData.cellDataArray.length; ++i)
            {
                data.cellDataArray.push(CellData.createFromJsonData(jsonData.cellDataArray[i]));
            }
        }
        return data;
    }
}

export class CellData
{
    // データタイプ
    // 0: テキスト
    public type : number = 0;
    // データ内容
    public content : string = "";

    public clone()
    {
        var cloned = new CellData();
        cloned.type = this.type;
        cloned.content = this.content;
        return cloned;
    }

    // JSON
    public toJSON()
    {
        // JSONパース用オブジェクト
        var cloneObj = {
            type : this.type,
            content : this.content
        };

        return cloneObj;
    }

    public static createFromJsonData(jsonData : any)
    {
        var cellData = new CellData();
        if(jsonData.type != null) { cellData.type = jsonData.type; }
        if(jsonData.content != null) { cellData.content = jsonData.content; }
        return cellData;
    }
}